import { jsxs as C, jsx as e } from "react/jsx-runtime";
import { c as s } from "./index-65016bfa.mjs";
import l, { css as i } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as I } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { ButtonV1 as _ } from "./buttonV1.js";
import { h as x } from "./hTag-27bb1617.mjs";
import { Icon as p } from "./icon.js";
import { Image as h } from "./image.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./Aria-f5e019e2.mjs";
import "./combineRefs-90f27925.mjs";
import "@fcamna/shared-icons";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
const W = l.div`
  &.CardIllustration__Wrapper {
    ${({
  theme: {
    components: { cardIllustration: r }
  }
}) => i(r.Wrapper)};
  }
`, $ = l.div`
  &.CardIllustration__ImageContainer {
    ${({
  theme: {
    components: { cardIllustration: r }
  }
}) => i(r.ImageContainer)};
  }
`, f = l(x)`
  &.CardIllustration__TitleWrapper {
    ${({
  theme: {
    components: { cardIllustration: r }
  }
}) => i(r.TitleWrapper)};
  }
`, g = l.div`
  &.CardIllustration__DescriptionWrapper {
    ${({
  theme: {
    components: { cardIllustration: r }
  }
}) => i(r.DescriptionWrapper)};
  }
`, z = l.div`
  &.CardIllustration__IconContainer {
    ${({
  theme: {
    components: { cardIllustration: r }
  }
}) => i(r.IconContainer)};
  }
`, v = l.div`
  &.CardIllustration__ButtonContainer {
    ${({
  theme: {
    components: { cardIllustration: r }
  }
}) => i(r.ButtonContainer)};
  }
`, c = {
  xxSmall: "xxs",
  xSmall: "xs",
  small: "s",
  medium: "m",
  large: "l",
  xLarge: "xl",
  xxLarge: "xxl",
  xxs: "xxs",
  xs: "xs",
  s: "s",
  m: "m",
  l: "l",
  xl: "xl",
  xxl: "xxl"
}, G = ({ mediaProps: r, titleProps: t, description: o, ctaProps: m, alignment: d = "center" }) => {
  const u = I({ label: "Card Illustration" }), { imageProp: n, iconProp: a } = r;
  return /* @__PURE__ */ C(
    W,
    {
      className: s(["CardIllustration", "CardIllustration__Wrapper", `CardIllustration__Wrapper--${d}Align`]),
      ...u,
      children: [
        n ? /* @__PURE__ */ e(
          $,
          {
            className: s(["CardIllustration__ImageContainer", `CardIllustration__ImageContainer--${(n == null ? void 0 : n.size) || "xxLarge"}`]),
            children: /* @__PURE__ */ e(
              h,
              {
                src: n == null ? void 0 : n.src,
                alt: n == null ? void 0 : n.alt,
                disclosureLinks: n == null ? void 0 : n.disclosureLinks,
                variant: "none"
              }
            )
          }
        ) : a != null && a.icon && typeof (a == null ? void 0 : a.icon) == "string" ? /* @__PURE__ */ e(
          p,
          {
            name: a == null ? void 0 : a.icon,
            size: (a == null ? void 0 : a.size) && c[a.size],
            extended: !0
          }
        ) : /* @__PURE__ */ e(
          z,
          {
            className: s([
              "CardIllustration__IconContainer",
              `CardIllustration__IconContainer--${(a == null ? void 0 : a.size) && c[a.size] || "l"}`
            ]),
            children: a == null ? void 0 : a.icon
          }
        ),
        /* @__PURE__ */ e(
          f,
          {
            as: (t == null ? void 0 : t.headingLevel) || "h1",
            className: s(["CardIllustration__TitleWrapper", `CardIllustration__TitleWrapper--${(t == null ? void 0 : t.size) || "xLarge"}`]),
            children: t == null ? void 0 : t.title
          }
        ),
        o && /* @__PURE__ */ e(g, { className: s(["CardIllustration__DescriptionWrapper"]), children: o }),
        m && /* @__PURE__ */ e(v, { className: s(["CardIllustration__ButtonContainer"]), children: /* @__PURE__ */ e(_, { ...m }) })
      ]
    }
  );
};
export {
  G as CardIllustration
};
